import * as C from '../constants';
import twentyService from '../../../services/twenty-service';

export default {

  /**
   * Sets session info
   *
   * @param commit
   * @param payload
   */
  setSessionInfo({ commit }, payload) {
    return new Promise((resolve) => {
      commit(C.APP_SESSION_INFO_SET, payload);
      resolve();
    });
  },

  /**
   * Resets session info
   *
   * @param commit
   * @returns {Promise<any>}
   */
  resetSessionInfo({ commit }) {
    return new Promise((resolve) => {
      commit(C.APP_SESSION_INFO_SET, { user: null, brands: null, products: null, suppliers: null });
      resolve();
    });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T | never>}
   */
  getDomainsByProductTypeId({ commit }, payload) {
    commit(C.APP_DOMAINS_PENDING);
    return twentyService.getDomainsByProductTypeId(payload)
      .then((res) => {
        commit(C.APP_DOMAINS_SUCCESS, res.data);
      }).catch((err) => {
        commit(C.APP_DOMAINS_FAILURE, err.message);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js